// İSG Portal — API hatasını kullanıcı diline çözme (istemci **koda göre** dallanır).
//
// Backend `errorCode` + `messageData` döner (api-contract §1/§2); metin çözümü
// istemcide dil paketinden yapılır. Eksik koda genel bir mesaj düşülür (ham kod
// sızmaz — [[feedback_i18n_key_runtime_path]]).

import type { TFunction } from 'i18next';
import { isApiError } from '../api/errors';

/**
 * `fallbackKey` verilirse eşlenmemiş kod (ya da `ApiError` olmayan hata) genel mesaj YERİNE bu
 * anahtarın metnine düşer — aksiyona özgü, daha açıklayıcı bir yedek (S24 `ConfirmDialog.errorFallback`,
 * GL12 giriş izni uyarısı). Bilinen kodlar (yerel katalog ya da dil paketi) yine KENDİ metnini kullanır.
 */
export function resolveApiErrorMessage(err: unknown, t: TFunction, fallbackKey?: string): string {
  const fallback = fallbackKey ? t(fallbackKey) : t('error.generic');
  if (!isApiError(err)) {
    return fallback;
  }
  return t(err.errorCode, {
    defaultValue: fallback,
    ...(err.messageData ?? {}),
  });
}
